import React, { useState, createContext, useContext } from 'react';

const FontSizeContext = createContext();

export function FontSizeProvider({ children }) {
  const [sizeLevel, setSizeLevel] = useState(0); // 0 = normal, 1 = large, 2 = extra-large

  const sizeClass = sizeLevel === 0 ? '' : sizeLevel === 1 ? 'text-scale-lg' : 'text-scale-xl';

  const cycleSize = () => setSizeLevel((sizeLevel + 1) % 3);

  const label = sizeLevel === 0 ? 'A' : sizeLevel === 1 ? 'A+' : 'A++';

  return (
    <FontSizeContext.Provider value={{ sizeLevel, sizeClass, cycleSize, label }}>
      <div className={sizeClass}>
        {children}
      </div>
    </FontSizeContext.Provider>
  );
}

export function useFontSize() {
  return useContext(FontSizeContext);
}
